import enumService from "@/api/services/enum-service";
import { queryOptions, useQuery } from "@tanstack/react-query";

// Query options
export const enumsQueryOptions = () =>
	queryOptions({
		queryKey: ["enums"],
		queryFn: () => enumService.getAll(),
		staleTime: 1000 * 60 * 60, // 1 hour - enums rarely change
	});

export const projectCategoryAttachmentsQueryOptions = () =>
	queryOptions({
		queryKey: ["enums", "project-category-attachments"],
		queryFn: () => enumService.getProjectCategoryAttachments(),
		staleTime: 1000 * 60 * 60, // 1 hour
	});

export const governmentProjectAttachmentsQueryOptions = () =>
	queryOptions({
		queryKey: ["enums", "project-category-attachments", "government"],
		queryFn: () => enumService.getGovernmentProjectAttachments(),
		staleTime: 1000 * 60 * 60, // 1 hour
	});

export const privateProjectAttachmentsQueryOptions = () =>
	queryOptions({
		queryKey: ["enums", "project-category-attachments", "private"],
		queryFn: () => enumService.getPrivateProjectAttachments(),
		staleTime: 1000 * 60 * 60, // 1 hour
	});

export const unitTypesQueryOptions = () =>
	queryOptions({
		queryKey: ["enums", "unit-types"],
		queryFn: () => enumService.getUnitTypes(),
		staleTime: 1000 * 60 * 60, // 1 hour
	});

export const periodTypesQueryOptions = () =>
	queryOptions({
		queryKey: ["enums", "period-types"],
		queryFn: () => enumService.getPeriodTypes(), // gets from enums service
		staleTime: 1000 * 60 * 60,
	});

export const markupRatesQueryOptions = () => 
	queryOptions({
		queryKey: ["enums", "markup-rates"],
		queryFn: () => enumService.getMarkupRates(),
		staleTime: 1000 * 60 * 60,
	});

// Hooks
export const useEnums = () => {
	return useQuery(enumsQueryOptions());
};

export const useProjectCategoryAttachments = () => {
	return useQuery(projectCategoryAttachmentsQueryOptions());
};

export const useGovernmentProjectAttachments = () => {
	return useQuery(governmentProjectAttachmentsQueryOptions());
};

export const usePrivateProjectAttachments = () => {
	return useQuery(privateProjectAttachmentsQueryOptions());
};

export const useUnitTypes = () => {
	return useQuery(unitTypesQueryOptions());
};

export const usePeriodTypes = () => {
	return useQuery(periodTypesQueryOptions());
}

export const useMarkupRates = () => {
	return useQuery(markupRatesQueryOptions());
}
